export default {
	'add-new-branch': '',
	'the-branch': '',
	branch: '',
	'contact-info': ''
}